import {
	setClaimExcludeIds,
	setclaimUuids,
	setDownloadAll,
} from 'feature/claims/claimsSlice';
import {
	handleChange,
	handleChangeClaimStatus,
	setSearch,
} from 'feature/form/formSlice';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as SearchHideIcon } from 'assett/icons/search_hide_icon.svg';
import { ReactComponent as SearchIcon } from 'assett/icons/search_icon.svg';
import SelectGeneric from 'components/commons/form/SelectGeneric';
import HeaderCellWithSorting from 'components/commons/list/HeaderCellWithSorting';
import useDevice from 'hooks/DesktopDevice.hook';
import { FC } from 'react';
import { AppDispatch, RootState } from 'store/store';
import { Box, DatePicker, TableCell, TableHead, TableRow } from 'styles';
import IconButton from 'styles/button/IconButton';
import Checkbox from 'styles/checkbox/Checkbox';
import { SubCollections } from 'types/Form';
import { useTranslation } from 'utils/translations';

const ClaimsHeader: FC<{}> = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});

	const { downloadAll } = useSelector((store: RootState) => store.claims);
	const {
		search,
		inputDateOfService,
		inputClaimStatus,
		claimsStatuses,
		subcollection,
		...inputs
	} = useSelector((store: RootState) => store.form);

	const isNotifications = subcollection === SubCollections.NOTIFICATION;

	const { notificationStatuses } = useSelector((store: RootState) => store.form);

	const { isDesktop } = useDevice();
	const dispatch = useDispatch<AppDispatch>();

	const handleSelect = (payload: string) => {
		dispatch(handleChangeClaimStatus(payload !== 'All' ? payload : ''));
	};

	const handleCheckDownload = () => {
		if (downloadAll) {
			dispatch(setDownloadAll(false));
			dispatch(setclaimUuids([]));
			dispatch(setClaimExcludeIds([]));
		} else {
			dispatch(setDownloadAll(true));
		}
	};

	return (
		<TableHead>
			<TableRow>
				<TableCell sx={{ width: 220, zIndex: '90!important' }}>
					<Checkbox
						label=""
						onClick={handleCheckDownload}
						checked={downloadAll}
						sx={{ p: 0 }}
						accessibilitylabel={`${tClientLabels('claim.labels.selectAllClaims')}`}
					/>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<HeaderCellWithSorting
						name="externalClaimId"
						value={inputs.inputExternalClaimId}
						widthBox={220}
						widthInput={220}
						noMargins
						primarySorting="serviceDate"
					/>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<HeaderCellWithSorting
						name="carrierClaimId"
						value={inputs.inputCarrierClaimId}
						widthBox={220}
						widthInput={220}
						noMargins
					/>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<HeaderCellWithSorting
						name="firstName"
						value={inputs.inputFirstName}
						widthBox={220}
						widthInput={220}
						primarySorting="externalClaimId"
						noMargins
					/>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<HeaderCellWithSorting
						name="lastName"
						value={inputs.inputLastName}
						widthBox={220}
						widthInput={220}
						primarySorting="externalClaimId"
						noMargins
					/>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<HeaderCellWithSorting
						name="serviceDate"
						widthBox={220}
						widthInput={220}
						primarySorting="externalClaimId"
						noMargins
					>
						<Box
							sx={{
								width: 220,
							}}
						>
							<DatePicker
								variant="field"
								label={tClientLabels('forms.header.serviceDate')}
								value={inputDateOfService}
								onChange={value => {
									dispatch(
										handleChange<any>({
											name: 'inputDateOfService',
											value: value,
										}),
									);
								}}
							/>
						</Box>
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell sx={{ width: !!isDesktop ? 230 : 220 }}>
					<HeaderCellWithSorting
						name="claimStatus"
						widthBox={!!isDesktop ? 240 : 220}
						widthInput={!!isDesktop ? 240 : 220}
						primarySorting="externalClaimId"
						noMargins
					>
						<SelectGeneric
							action={(payload: string) => handleSelect(payload)}
							items={[
								{ value: 'All', text: tClientLabels('forms.status.All') },
								...(isNotifications ? notificationStatuses : claimsStatuses).map(
									el => ({
										value: el.name,
										text: tDbLabels(el.label),
									}),
								),
							]}
							name={'claim'}
							sx={{ width: !!isDesktop ? 230 : 220 }}
							initialValue={inputClaimStatus || 'All'}
						/>
					</HeaderCellWithSorting>
				</TableCell>

				<TableCell sx={{ width: '100%', textAlign: 'right' }}>
					<IconButton
						onClick={() => dispatch(setSearch(!search))}
						sx={{ ml: !!isDesktop ? 0 : 4.2 }}
					>
						{search ? <SearchHideIcon /> : <SearchIcon />}
					</IconButton>
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default ClaimsHeader;
